import React from 'react';
import { FilterText, Status } from '../../../constants/Invitations';

const SCHEMA_TABLE_FONT_FAMILY = `-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",
    Arial,"Noto Sans","Liberation Sans",sans-serif,"Apple Color Emoji",
    "Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"`;

const getSchemaSettings = (
    selectAllRows,
    selectRow,
    securityGroupOptions,
    onClick,
    setFilteredRows,
    saveSort
) => {

    const handleSelectAll = (isChecked, filteredRowIds) => selectAllRows(isChecked, filteredRowIds);
    const handleSelect = (key, isChecked) => selectRow(key, isChecked);

    const onFilter = filteredRowIds => {
        setFilteredRows(filteredRowIds);
    };

    const onSort = (field, order) => {
        saveSort(field, order);
    };

    const options = {
        bootstrap4: true,
        bordered: false,
        showPagination: true,
        keyName: 'key',
        keyField: 'key',
        sizePerPage: 25,
        showFilters: true,
        striped: true,
        condensed: false,
        defaultSorted: [{
            dataField: 'status',
            order: 'desc'
        }],
        defaultSortDirection: 'asc',
        paginationOptions: {
            sizePerPage: 25,
            page: 1,
            alwaysShowAllBtns: true,
            hideSizePerPage: false,
            sizePerPageList: [25, 30, 50]
        },
        selectRow: {
            selectColumnPosition: 'left',
            onSelectAll: (isChecked, filteredRowIds) => {
                handleSelectAll(isChecked, filteredRowIds);
            },
            onSelect: (row, isChecked) => {
                handleSelect(row.key, isChecked);
            }
        },
        noDataIndication: 'No data found',
        filterPosition: 'top',
        onFilter: onFilter
    };

    const properties = {
        key: {
            type: 'number',
            hidden: true
        },
        status: {
            format: 'enum',
            title: 'Status',
            filterOptions: {
                placeholder: 'Select Status...'
            },
            formatter: (cell, row) => row.statusBtn,
            options: {
                [Status.INVITED]: FilterText.INVITED,
                [Status.PENDINGAPPROVAL]: FilterText.PENDINGAPPROVAL,
                [Status.APPROVED]: FilterText.APPROVED,
                [Status.INACTIVE]: FilterText.INACTIVE
            },
            headerStyle: {
                fontFamily: SCHEMA_TABLE_FONT_FAMILY,
                fontWeight: 'normal',
                width: '150px',
                verticalAlign: 'middle'
            },
            onSort: onSort
        },
        emailAddress: {
            type: 'string',
            title: 'Email',
            editable: false,
            formatter: (cell, row) => <a className={'text-primary'} onClick={() => onClick(row)}>{cell}</a>,
            style: { fontFamily: SCHEMA_TABLE_FONT_FAMILY },
            headerStyle: {
                fontFamily: SCHEMA_TABLE_FONT_FAMILY,
                fontWeight: 'normal',
                verticalAlign: 'middle'
            },
            onSort: onSort
        },
        userName: {
            type: 'string',
            title: 'Name',
            style: { fontFamily: SCHEMA_TABLE_FONT_FAMILY },
            headerStyle: {
                fontFamily: SCHEMA_TABLE_FONT_FAMILY,
                fontWeight: 'normal',
                verticalAlign: 'middle'
            },
            onSort: onSort
        },
        securityGroup: {
            title: 'Security Group',
            format: 'enum',
            options: securityGroupOptions,
            filterValue: cell => cell?.id,
            sortValue: cell => cell?.name || '',
            formatter: cell => cell?.name,
            style: { fontFamily: SCHEMA_TABLE_FONT_FAMILY },
            headerStyle: {
                fontFamily: SCHEMA_TABLE_FONT_FAMILY,
                fontWeight: 'normal',
                verticalAlign: 'middle'
            },
            onSort: onSort
        },
        statusDate: {
            type: 'date',
            format: 'date-picker',
            title: 'Status Change Date',
            style: { fontFamily: SCHEMA_TABLE_FONT_FAMILY },
            headerStyle: {
                fontFamily: SCHEMA_TABLE_FONT_FAMILY,
                fontWeight: 'normal',
                verticalAlign: 'middle'
            },
            filterOptions: {
                placeholderText: 'Enter Status Date...',
                className: 'form-control dp-filter-className'
            },
            sortValue: cell => cell || new Date(0),
            onSort: onSort
        }
    };

    return {
        options: options,
        schema: { properties }
    };
};

export default getSchemaSettings;